import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch("/api/me", {
          credentials: "include",
        });

        if (res.ok) {
          const data = await res.json();
          setUser(data.user);
          if (data.user?.role === "Админ") {
            navigate("/admin/dashboard/home");
          }
        } else {
          navigate("/login");
        }
      } catch (err) {
        console.error("❌ Failed to fetch user", err);
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  if (loading) {
    return <div className="text-center p-10 text-lg text-gray-400">Loading dashboard...</div>;
  }

  return (
    <div className="flex flex-col items-center justify-start pt-16 min-h-screen bg-gradient-to-br from-[#e0f2fe] via-[#f8fafc] to-[#f0fdf4] text-center">
      <div className="bg-white rounded-2xl shadow-2xl p-10 max-w-lg w-full border border-gray-100 animate-fade-in">
        <img
          src={user?.avatar || '/default-avatar.png'}
          alt="avatar"
          className="w-32 h-32 rounded-full shadow-lg mx-auto mb-6 border-4 border-green-100"
        />
        <h1 className="text-3xl font-extrabold text-[#173861] mb-2">{user?.name || "No Name"}</h1>
        <p className="text-lg text-gray-600 font-semibold mb-1">{user?.role || "No Role"}</p>
        <p className="text-base text-gray-500">{user?.email}</p>
      </div>
    </div>
  );
};

export default Dashboard;
